import produce from 'immer';

import { defaultState } from './defaultState';
import type { AntePostEventsHandlerResponseBody } from './types';

type State = typeof defaultState;

export const reducers = {
  clear: (): State => produce(defaultState, (draft) => draft),
  antepostEventsRequested: (
    state: State,
    { isBackgroundLoading = false }: { isBackgroundLoading?: boolean } = {}
  ): State => ({
    ...state,
    isLoading: !isBackgroundLoading
  }),
  dataLoadSuccess: (state: State, payload: AntePostEventsHandlerResponseBody): State => ({
    ...state,
    ...payload,
    isLoading: false,
    hasPreloaded: true,
    errorCode: undefined
  }),
  dataLoadFailed: (state: State, payload: number): State => ({
    ...state,
    isLoading: false,
    hasPreloaded: true,
    errorCode: payload
  })
};
